//console.log("home.js");

document.addEventListener('DOMContentLoaded', function () {  
  setTrueHeight();
});

let setTrueHeight = function() {
  let trueHeight = window.innerHeight;

  let isAnnoucementOn = document.querySelector(".announcement-on");

  let subtractHeight = 120;

  if (isAnnoucementOn) {
    subtractHeight = 180;
  }

  let trueHeightsHeader =  trueHeight - subtractHeight;
  let homeSwiper = document.querySelectorAll('.home-swiper');

  if (window.innerWidth <= 500) {
    homeSwiper.forEach(item => {
      item.style.height = trueHeightsHeader + "px";
    });
  } else {
    homeSwiper.forEach(item => {
      item.style.height = "";
    });
  }
};

let homeSwiper = document.querySelector(".home-swiper");

if(homeSwiper){
  var hSwiper = new Swiper(homeSwiper, {
    loop: true,
    navigation: {
      nextEl: ".home-swiper .swiper-button-next",
      prevEl: ".home-swiper .swiper-button-prev",
    },
    pagination: {
      el: ".home-swiper .swiper-pagination",
      clickable: true,
    },
  });
}

//Press Swiper
let pressSwiper = document.querySelector(".press-swiper");

if(pressSwiper){
  var pSwiper = new Swiper(pressSwiper, {
    //loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: ".press-swiper .swiper-button-next",
      prevEl: ".press-swiper .swiper-button-prev"
    },
    pagination: {
      el: ".press-swiper .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      500: {
        slidesPerView: 1,
        spaceBetween: 12
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 12
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 12
      }
    }
  });
}

//window.addEventListener("resize", setTrueHeight);